import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { PublicationYearRange, QuestionBytesLimit } from './constants';
import { useRepositories } from '@/plugins/repositories';
import { useStore } from '@/store/useStore';
import { useTelemetry } from '@/plugins/telemetry';
import { useAuth } from '@/plugins/auth';
import InputFormTitleFilter from './input-form-title-filter.vue';
import { WandhAvailableBooks } from 'wklr-shared/dist/constants';
import { useToast } from '@/plugins/vueToast';
import { useWandhAvailableModels } from './model';
import WklrIconBtn from '@/components/shared/wklr-icon-btn.vue';
export default defineComponent({
  name: 'LabsWandhInputForm',
  components: {
    InputFormTitleFilter: InputFormTitleFilter,
    WklrIconBtn: WklrIconBtn
  },
  props: {
    state: {
      type: String,
      required: true
    },
    abortController: {
      type: AbortController,
      required: false,
      default: null
    },
    showCloseButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var store = useStore();
    var auth = useAuth();
    var $repositories = useRepositories();
    var isSearching = ref(false);
    var plan = auth.user.labsWandhPlan;
    var showStandardModelRemainingQuota = !!plan && plan.maxSearchTotal !== null;
    var showAdvancedModelRemainingQuota = !!plan && plan.maxSearchBoost !== null;
    var inputQuestion = computed({
      get: function get() {
        return store.state.persistent.labs.wandh.inputQuery.question;
      },
      set: function set(newVal) {
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          question: newVal
        }));
      }
    });
    var publishedOnOrAfter = computed({
      get: function get() {
        return store.state.persistent.labs.wandh.inputQuery.filter.publishedOnOrAfterYear;
      },
      set: function set(newVal) {
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
            publishedOnOrAfterYear: newVal
          })
        }));
      }
    });
    var model = computed({
      get: function get() {
        return store.state.persistent.labs.wandh.inputQuery.model;
      },
      set: function set(newVal) {
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          model: newVal
        }));
      }
    });
    var documentType = computed({
      get: function get() {
        return store.state.persistent.labs.wandh.inputQuery.filter.documentType;
      },
      set: function set(newVal) {
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
            documentType: newVal
          })
        }));
      }
    });
    var inputQuestionBytes = computed(function () {
      return new TextEncoder().encode(inputQuestion.value.trim()).length;
    });
    var quota = computed(function () {
      return store.state.persistent.labs.wandh.quota;
    });

    /** ユーザーが利用可能なモデルの一覧 */
    var availableModels = useWandhAvailableModels();
    var standardModelRemainingQuota = computed(function () {
      var _quota$value, _quota$value$remainin;
      return (_quota$value = quota.value) === null || _quota$value === void 0 ? void 0 : (_quota$value$remainin = _quota$value.remainingQuotaByModel.standard.remainingQuota) === null || _quota$value$remainin === void 0 ? void 0 : _quota$value$remainin.toLocaleString();
    });
    var advancedModelRemainingQuota = computed(function () {
      var _quota$value2, _quota$value2$remaini;
      return (_quota$value2 = quota.value) === null || _quota$value2 === void 0 ? void 0 : (_quota$value2$remaini = _quota$value2.remainingQuotaByModel.advanced.remainingQuota) === null || _quota$value2$remaini === void 0 ? void 0 : _quota$value2$remaini.toLocaleString();
    });
    var repositories = useRepositories();
    var router = useRouter();
    var telemetry = useTelemetry();
    var route = useRoute();
    var isAllBooksSelected = computed(function () {
      return store.state.persistent.labs.wandh.inputQuery.filter.id.store === null && store.state.persistent.labs.wandh.inputQuery.filter.id.other === null;
    });
    var isAskable = computed(function () {
      var _inputQuery$value, _inputQuery$value2;
      return (
        // プランが取得できている
        plan !== undefined &&
        // 文献が選択されている。lawは常に選択されているのでlengthは1より常に大きくなければならない
        documentType.value.length > 1 && (
        // 書籍以外が選択されているか、書籍フィルターが空でない
        documentType.value.includes('case') || documentType.value.includes('guideline') || !((_inputQuery$value = inputQuery.value) !== null && _inputQuery$value !== void 0 && _inputQuery$value.filter.id) || ((_inputQuery$value2 = inputQuery.value) === null || _inputQuery$value2 === void 0 ? void 0 : _inputQuery$value2.filter.id.length) > 0) && (
        // W&Hが動作中でない
        props.state === 'idle' || props.abortController) &&
        // 質問が入力されている
        inputQuestionBytes.value > 0 &&
        // 質問が文字数制限内
        inputQuestionBytes.value <= QuestionBytesLimit && (
        // 期間指定がされている。未入力は undefined, 空にすると '' になる
        publishedOnOrAfter.value === undefined || publishedOnOrAfter.value === '' || Number.isInteger(publishedOnOrAfter.value)) &&
        // モデルに残り回数がある
        hasRemainingQuota.value &&
        // 検索中でない
        !isSearching.value
      );
    });
    var hasRemainingQuota = computed(function () {
      var _quota$value3, _quota$value4;
      return (
        // nullの場合は無制限なので常にtrue
        !!plan && plan.maxSearchTotal === null || quota.value && ((_quota$value3 = quota.value) === null || _quota$value3 === void 0 ? void 0 : _quota$value3.remainingQuotaByModel.standard.remainingQuota) !== null && ((_quota$value4 = quota.value) === null || _quota$value4 === void 0 ? void 0 : _quota$value4.remainingQuotaByModel.standard.remainingQuota) > 0
      );
    });
    var hasAdvancedModelRemainingQuota = computed(function () {
      var _quota$value5, _quota$value6;
      return (
        // nullの場合は無制限なので常にtrue
        !!plan && plan.maxSearchBoost === null || quota.value && ((_quota$value5 = quota.value) === null || _quota$value5 === void 0 ? void 0 : _quota$value5.remainingQuotaByModel.advanced.remainingQuota) !== null && ((_quota$value6 = quota.value) === null || _quota$value6 === void 0 ? void 0 : _quota$value6.remainingQuotaByModel.advanced.remainingQuota) > 0
      );
    });
    var showPlanNotice = computed(function () {
      return !plan;
    });
    var handleEnter = function handleEnter(event) {
      if (!event.isComposing && isAskable.value) {
        ask();
      }
    };
    var toast = useToast();
    var ask = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!inputQuery.value || isSearching.value)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              isSearching.value = true;
              _context.next = 6;
              return repositories.labs.preparePostLabsWandhQuestion(inputQuery.value);
            case 6:
              res = _context.sent;
              store.commit('setLabsWandhStreamParams', res);
              inputQuestion.value = '';
              telemetry.sendWandhAskTelemetry({
                action: 'ask',
                state: props.state
              }, route);
              router.push({
                path: "/labs/wandh/q/".concat(res.historyId)
              });
              _context.next = 24;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              if (!(_context.t0 instanceof Error)) {
                _context.next = 21;
                break;
              }
              toast.error(_context.t0.message);
              telemetry.sendErrorTelemetry(_context.t0, route);
              // Sentry がキャッチしてくれることを想定して再 throw
              throw _context.t0;
            case 21:
              toast.error('予期せぬ問題が発生しました');
              telemetry.sendErrorTelemetry(new Error(String(_context.t0)), route);
              throw new Error(String(_context.t0));
            case 24:
              _context.prev = 24;
              isSearching.value = false;
              return _context.finish(24);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 13, 24, 27]]);
      }));
      return function ask() {
        return _ref2.apply(this, arguments);
      };
    }();
    var availableBooks = ref({
      store: [],
      other: WandhAvailableBooks
    });
    provide('availableBooks', availableBooks);
    var inputQuery = computed(function () {
      var _store$state$persiste, _store$state$persiste2;
      if (!model.value) {
        return null;
      }
      var filter = {};
      if (typeof publishedOnOrAfter.value === 'number') {
        filter.publishedOnOrAfterYear = publishedOnOrAfter.value;
      }
      filter.documentType = documentType.value;
      // genre のみ上記の変換をしているためストアを直接見る
      if (store.state.persistent.labs.wandh.inputQuery.filter.genre.length) {
        filter.genre = store.state.persistent.labs.wandh.inputQuery.filter.genre;
      }

      // FIXME: API上でも { store: null, other: null } 的に送ってクエリログを短くできるべき
      //        いずれにせよlabs-wandh側でユーザーがアクセスできる書籍リストは取得・チェックしないといけないので、
      //        実装量はさほど増えない
      filter.id = [].concat(_toConsumableArray((_store$state$persiste = store.state.persistent.labs.wandh.inputQuery.filter.id.store) !== null && _store$state$persiste !== void 0 ? _store$state$persiste : availableBooks.value.store.map(function (book) {
        return book.naturalID;
      })), _toConsumableArray((_store$state$persiste2 = store.state.persistent.labs.wandh.inputQuery.filter.id.other) !== null && _store$state$persiste2 !== void 0 ? _store$state$persiste2 : availableBooks.value.other.map(function (book) {
        return book.naturalID;
      }))).sort();
      return {
        question: inputQuestion.value.trim(),
        model: model.value,
        filter: filter
      };
    });
    onBeforeMount(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var res, _availableModels$valu;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // とりあえず大きい数字
            $repositories.users.purchasedDocuments(3000).then(function (docs) {
              availableBooks.value = _objectSpread(_objectSpread({}, availableBooks.value), {}, {
                store: docs.map(function (d) {
                  return {
                    naturalID: d.id,
                    title: d.title
                  };
                })
              });
            });
            _context2.next = 3;
            return repositories.labs.getLabsWandhQuota();
          case 3:
            res = _context2.sent;
            store.commit('updateLabsWandhQuota', res);
            if (!hasRemainingQuota.value) {
              // undefinedにしないとv-btn-toggleのbtnが全てactiveになる
              model.value = undefined;
            } else if (!model.value || !hasAdvancedModelRemainingQuota.value) {
              model.value = (_availableModels$valu = availableModels.value) === null || _availableModels$valu === void 0 ? void 0 : _availableModels$valu.standard;
            }
            store.dispatch('initializeWandhInputQuery');
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));

    // TODO 新規質問の入力 watcher 内で start-writing-new テレメトリを送る
    // #471 がマージされたら追加する

    var handleTicketTooltipClick = function handleTicketTooltipClick() {
      telemetry.sendClickTelemetry({
        button: 'wandh-input-form__ticket-tooltip'
      }, route);
    };
    var handleClose = function handleClose() {
      emit('close');
    };
    var isSingleDocumentType = function isSingleDocumentType(type) {
      // lawは常に選択されているのでlengthが2のとき一つのドキュメントタイプしか選択されていないと判断できる
      return documentType.value.length === 2 && documentType.value.includes(type);
    };
    watch(documentType, function (newVal, oldVal) {
      if (!oldVal.includes('book') && newVal.includes('book')) {
        // 種別で書籍を追加したときには、書籍リストを全選択状態に戻す
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
            id: {
              store: null,
              other: null
            }
          })
        }));
      }
    });
    return {
      PublicationYearRange: PublicationYearRange,
      QuestionBytesLimit: QuestionBytesLimit,
      quota: quota,
      showStandardModelRemainingQuota: showStandardModelRemainingQuota,
      showAdvancedModelRemainingQuota: showAdvancedModelRemainingQuota,
      standardModelRemainingQuota: standardModelRemainingQuota,
      advancedModelRemainingQuota: advancedModelRemainingQuota,
      hasRemainingQuota: hasRemainingQuota,
      hasAdvancedModelRemainingQuota: hasAdvancedModelRemainingQuota,
      inputQuestion: inputQuestion,
      inputQuestionBytes: inputQuestionBytes,
      publishedOnOrAfter: publishedOnOrAfter,
      documentType: documentType,
      isAllBooksSelected: isAllBooksSelected,
      isAskable: isAskable,
      showPlanNotice: showPlanNotice,
      handleEnter: handleEnter,
      ask: ask,
      handleTicketTooltipClick: handleTicketTooltipClick,
      handleClose: handleClose,
      WandhAvailableBooks: WandhAvailableBooks,
      auth: auth,
      model: model,
      availableModels: availableModels,
      isSingleDocumentType: isSingleDocumentType
    };
  }
});